import { Injectable } from '@angular/core';
import { ApiRouteMoldRevisionService } from '../../../api/elite/routes/mold-revision.service';
import { MoldRevisionApiRoutesDto } from '../../../api/elite/dto/mold-revision.dto';
import { MoldRevision } from '../../../api/elite/types/mold-revision';
import { Observable, of } from 'rxjs';
import { MoldType } from '../../../api/elite/types/mold-type';
import { ApiRouteMoldsService } from '../../../api/elite/routes/molds.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ApiFilesSaPlasticDto } from 'src/app/api/files/dto/sa-plastic.dto';
import { ApiFilesPlasticService } from 'src/app/api/files/routes/plastic.service';

@Injectable({
  providedIn: 'root',
})
export class MoldFormApiService {
  constructor(
    protected readonly moldRevisionApiRouter: ApiRouteMoldRevisionService,
    protected readonly moldApiRouter: ApiRouteMoldsService,
    private readonly apiFilesPlasticService: ApiFilesPlasticService
  ) {}

  // getMolds(departmentName: string): Observable<MoldRevision[]> {
  //   return this.moldApiRouter.getMolds(departmentName);
  // }

  createMold(
    body: MoldRevisionApiRoutesDto['create']['body']
  ): Observable<MoldRevision> {
    const file = body.image as File | null;
    const version = body.version ?? 1;

    if (file) {
      const [, subtype] = file.type.toLowerCase().split('/');

      body.imageData = {
        file: {
          name: file.name,
          storageName: String(version),
          typeDocument: subtype,
          active: true,
        },
        Resource: {
          resourceType: 'Mold Images',
          department: body.department,
        },
      };
    }

    delete body.image;
    delete body.version;
    delete body.department;

    return this.moldRevisionApiRouter.create(body).pipe(
      switchMap((createdMold) => {
        if (!file) {
          return of(createdMold);
        }

        const uploadData: ApiFilesSaPlasticDto['postImage']['body'] = {
          file,
          version: String(version),
          imageType: body.imageData.file.typeDocument,
          root: createdMold.moldId.toString(),
          departament: body.imageData.Resource.department,
          type: 'Mold Images',
        };

        return this.apiFilesPlasticService.postImage(uploadData).pipe(
          catchError(() => of(null)),
          map(() => createdMold)
        );
      })
    );
  }

  moldTypes(): Observable<MoldType[]> {
    return this.moldApiRouter.moldTypes();
  }
  moldTypesByDepartment(department: string): Observable<MoldType[]> {
    return this.moldApiRouter.moldTypesByDepartment(department);
  }
}
